import {toastr} from 'react-redux-toastr';
import {
  putJsonAsync,
  postJsonAsync,
  getJsonAsync
} from 'shared/actions';
import {initialize} from 'redux-form';
import {
  deactivateProcessStart,
  deactivateProcessEnd,
  cancelDeactivateModal,
  setEventTypesInState,
  displayInactiveFees,
  displayActiveFees,
  displayNewFee,
  cancelFeeItemForm
} from './actionTypes';

export const deactivateFee = feeId => (dispatch, getState) => {
  const tournament = getState().tournament.base.tournamentInfo;

  dispatch(deactivateProcessStart());
  dispatch(putJsonAsync(`addonfee/${feeId}/deactivate`))
  .then(() => {
    dispatch(deactivateProcessEnd());
    dispatch(cancelDeactivateModal());
    dispatch(retrieveActiveFees(tournament.id));
    dispatch(retrieveInactiveFees(tournament.id));
    toastr.success('Saved!', 'Add-on fee saved successfully.');
  })
  .catch(() => dispatch(deactivateProcessEnd()));
};

export const retrieveEventTypes = tournamentId => dispatch => {
  dispatch(getJsonAsync(`tournament/${tournamentId}/events/`))
  .then(data => dispatch(setEventTypesInState(data.map(({id, name}) => ({
    value: id,
    label: name
  })))));
};

export const validate = values => {
  let errors = {};

  if(!values.description) {
    errors.description = 'Required';
  }
  if(!values.eventId) {
    errors.eventId = 'Required';
  }
  if(!values.fee) {
    errors.fee = 'Required';
  }

  return errors;
};

export const handleSave = data => (dispatch, getState) => new Promise((resolve) => {
  const tournament = getState().tournament.base.tournamentInfo;

  dispatch(postJsonAsync('addonfee', data))
  .then(() => {
    toastr.success('Saved!', 'Add-on fee saved successfully.');
    dispatch(retrieveActiveFees(tournament.id));
    resolve();
  })
  .catch(() => resolve());
});

export const handleCancel = () => dispatch => dispatch(cancelFeeItemForm());

export const handleNewFeeClick = () => dispatch => {
  dispatch(cancelFeeItemForm());
  dispatch(displayNewFee());
  dispatch(initialize('feeItemForm', {}));
};

export const retrieveInactiveFees = tournamentId => dispatch => {
  dispatch(getJsonAsync(`tournament/${tournamentId}/fees/inactive`))
  .then(data => dispatch(displayInactiveFees(data)));
};

export const retrieveActiveFees = tournamentId => dispatch => {
  dispatch(getJsonAsync(`tournament/${tournamentId}/fees/active`))
  .then(data => dispatch(displayActiveFees(data)));
};



// WEBPACK FOOTER //
// ./src/features/tournament/fees/actions.js